import React, { useState, useEffect, useReducer } from 'react'
import { Button, ButtonGroup, Checkbox, Modal, Row, Table } from 'rsuite'
import { budgetFormat } from '../../utils/formatterUtil'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import { Controller, useForm } from 'react-hook-form'
import notification from '../../utils/notification'
import { maskIdCard } from '../../utils/dataUtil'

export default function PrePaymentList({ schema: _schema, handleOnSubmit, ...props }) {
  const { register, handleSubmit, errors, control, getValues, setValue, clearErrors } = useForm()
  const { Column, HeaderCell, Cell } = Table
  const [formSchema, setFormSchema] = useState(_schema)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [checkedKeys, setCheckedKeys] = useState([])
  const [countSelected, setCountSelected] = useState(0)
  const [indeterminate, setIndeterminate] = useState(false)
  const [tableData, setTableData] = useState([])
  const [buttonType, setButtonType] = useState(false)

  useEffect(() => {
    if (_schema) {
      setTableData(_schema.values || [])
      setFormSchema(_schema)
    }
  }, [_schema])

  const onSubmit = () => {
    // console.log('data', data)
    const request = {
      ids: checkedKeys,
      buttonType: buttonType,
    }
    setIsShowConfirm(false)
    handleOnSubmit(request)
  }

  const handleCheckAll = (value, checked) => {
    let newArr = []
    var checkedKeys = checked ? tableData.map((item) => item.id) : []
    tableData.map((item) => {
      if (!item.isTotal) {
        newArr.push(item.id)
      }
    })
    checkedKeys = checkedKeys.filter((item) => item != null)
    setCheckedKeys(checkedKeys)
    setCountSelected(newArr.length)
  }

  const handleCheck = (value, checked) => {
    const nextCheckedKeys = checked
      ? [...checkedKeys, value]
      : checkedKeys.filter((item) => item !== value)

    setCheckedKeys(nextCheckedKeys)
    setCountSelected(nextCheckedKeys.length)
  }

  const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => {
    if (rowData.isTotal) {
      return <Cell {...props} style={{ padding: 0 }}></Cell>
    }

    return (
      <Cell {...props} style={{ padding: 0 }}>
        <div style={{ lineHeight: '46px' }}>
          <Checkbox
            value={rowData[dataKey]}
            inline
            onChange={onChange}
            checked={checkedKeys.some((item) => item === rowData[dataKey])}
            style={{ marginLeft: -30 }}
          />
          {props.rowIndex + 1}
        </div>
      </Cell>
    )
  }

  return (
    <>
      <Row style={{ textAlign: 'end', marginTop: 10 }}>
        <ButtonGroup>
          <SaveButton
            disabled={isLoading}
            onClick={(e) => {
              if (checkedKeys.length > 0) {
                setIsShowConfirm(true)
                setButtonType(true)
              } else {
                notification.open('error', {
                  title: 'กรุณาเลือกรายการ',
                  duration: 5000,
                })
              }
            }}
          >
            {formSchema?.buttonTxt?.annualTaxSave}
          </SaveButton>
        </ButtonGroup>
      </Row>

      <Table
        wordWrap
        autoHeight
        data={formSchema?.values || []}
        style={{ marginTop: 10 }}
        headerHeight={70}
      >
        <Column width={95} align="center">
          <HeaderCell style={{ padding: 0 }}>
            <div style={{ lineHeight: '40px' }}>
              <Controller
                name="chkRow"
                control={control}
                render={(props) => {
                  return (
                    <Checkbox
                      inline
                      checked={props.value}
                      indeterminate={indeterminate}
                      onChange={(e, checked) => {
                        props.onChange(checked)
                        handleCheckAll(null, checked)
                      }}
                      style={{ marginLeft: -10 }}
                    >
                      <b>ลำดับ</b>
                    </Checkbox>
                  )
                }}
              />
            </div>
          </HeaderCell>

          <CheckCell
            dataKey="id"
            checkedKeys={checkedKeys}
            onChange={(value, checked) => {
              handleCheck(value, checked)
            }}
          />
        </Column>

        <Column width={170} resizable align="left">
          <HeaderCell>ปี พ.ศ.(ปีภาษีที่หัก)</HeaderCell>
          <Cell dataKey="withholdingYear" />
        </Column>
        <Column width={160} resizable align="left">
          <HeaderCell>เดือน(ปีภาษีที่หัก)</HeaderCell>
          <Cell dataKey="withholdingMonthLabel" />
        </Column>
        <Column width={160} resizable align="left">
          <HeaderCell>วันเดือนปีจ่าย</HeaderCell>
          <Cell dataKey="datePayment" />
        </Column>
        <Column width={160} resizable align="left">
          <HeaderCell>รหัสโครงการ</HeaderCell>
          <Cell dataKey="projectCode" />
        </Column>
        <Column width={160} resizable align="left">
          <HeaderCell>เลขที่ข้อตกลง</HeaderCell>
          <Cell dataKey="contractNo" />
        </Column>
        <Column width={160} resizable align="left">
          <HeaderCell>ประเภทแบบ</HeaderCell>
          <Cell dataKey="withholdingType" />
        </Column>
        <Column width={180} resizable align="left">
          <HeaderCell>สถานะยื่นแบบ</HeaderCell>
          <Cell dataKey="submitStatus" />
        </Column>
        <Column width={160} resizable align="left">
          <HeaderCell>ที่มาข้อมูล</HeaderCell>
          <Cell dataKey="dataSource" />
        </Column>
        <Column width={160} resizable align="left">
          <HeaderCell>เลขลำดับนำส่ง</HeaderCell>
          <Cell dataKey="runingSequenceNo" />
        </Column>
        <Column width={190} resizable colSpan={3} align="left">
          <HeaderCell>เลขประจำตัวผู้เสียภาษี</HeaderCell>
          <Cell>
            {(rowData) => {
              if (rowData.isTotal) {
                return (
                  <p style={{ textAlign: 'center' }}>
                    <b>{maskIdCard(rowData.taxId)}</b>
                  </p>
                )
              }
              return maskIdCard(rowData.taxId)
            }}
          </Cell>
        </Column>
        <Column width={300} resizable align="left">
          <HeaderCell>ชื่อ</HeaderCell>
          <Cell dataKey="fullName" />
        </Column>

        <Column width={300} resizable align="left">
          <HeaderCell>ที่อยู่</HeaderCell>
          <Cell dataKey="address" />
        </Column>
        <Column width={150} resizable align="left">
          <HeaderCell>สาขา</HeaderCell>
          <Cell dataKey="branch" />
        </Column>
        <Column width={180} resizable align="left">
          <HeaderCell>วันเดือนปีที่จ่าย</HeaderCell>
          {/* <Cell dataKey="datePayment" /> */}
          <Cell>
            {(rowData) => {
              if (rowData.isTotal) {
                return (
                  <p style={{ textAlign: 'center' }}>
                    <b>{rowData.datePayment}</b>
                  </p>
                )
              }
              return rowData.datePayment
            }}
          </Cell>
        </Column>

        <Column width={150} resizable>
          <HeaderCell>จำนวนเงินที่จ่าย</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              if (rowData.isTotal) {
                return <b>{budgetFormat(rowData.amountPaid || 0)}</b>
              }
              return budgetFormat(rowData.amountPaid || 0)
            }}
          </Cell>
        </Column>

        <Column width={170} resizable>
          <HeaderCell>จำนวนเงินภาษีที่หัก</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              if (rowData.isTotal) {
                return <b>{budgetFormat(rowData.amountTax || 0)}</b>
              }
              return budgetFormat(rowData.amountTax || 0)
            }}
          </Cell>
        </Column>

        <Column width={150} resizable align="left">
          <HeaderCell>เงื่อนไขการหัก</HeaderCell>
          <Cell dataKey="withholdingConditions" />
        </Column>

        <Column width={150} resizable align="left">
          <HeaderCell>วันเดือนปีที่นำส่ง</HeaderCell>
          <Cell dataKey="datePaymentSubmission" />
        </Column>

        <Column width={150} resizable>
          <HeaderCell>จำนวนเงินที่จ่าย</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              if (rowData.isTotal) {
                return <b>{budgetFormat(rowData.amountPaidSubmission || 0)}</b>
              }
              return budgetFormat(rowData.amountPaidSubmission || 0)
            }}
          </Cell>
        </Column>
        <Column width={160} resizable>
          <HeaderCell>จำนวนเงินภาษีที่หักและนำส่ง</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              if (rowData.isTotal) {
                return <b>{budgetFormat(rowData.amountTaxSubmission || 0)}</b>
              }
              return budgetFormat(rowData.amountTaxSubmission || 0)
            }}
          </Cell>
        </Column>
        <Column width={190} resizable align="left">
          <HeaderCell>ยื่นแบบ (ปกติ/เพิ่มเติม)</HeaderCell>
          <Cell dataKey="filingType" />
        </Column>
        <Column width={170} resizable align="left">
          <HeaderCell>วันเดือนปีที่ชำระเงิน</HeaderCell>
          <Cell dataKey="datePaymentTax" />
        </Column>
        <Column width={160} resizable align="left">
          <HeaderCell>หมายเลขที่อ้างอิงในการยื่นแบบ</HeaderCell>
          <Cell dataKey="referenceNumber" />
        </Column>
        <Column width={150} resizable align="left">
          <HeaderCell>เลขที่ใบเสร็จรับเงิน</HeaderCell>
          <Cell dataKey="receiptNumberSubmission" />
        </Column>
        <Column width={150} resizable align="left">
          <HeaderCell>เงินได้ตามมาตรา</HeaderCell>
          <Cell dataKey="incomeAccording" />
        </Column>
        <Column width={140} resizable align="left">
          <HeaderCell>ประเภทแบบที่ยื่นเพื่อรายงานสรรพากรสิ้นปี</HeaderCell>
          <Cell dataKey="typeSubmitted" />
        </Column>
        <Column width={150} resizable align="left">
          <HeaderCell>วันเดือนปีที่นำส่ง</HeaderCell>
          <Cell dataKey="dateSubmission" />
        </Column>
        <Column width={160} resizable align="left">
          <HeaderCell>เลขที่ใบเสร็จรับเงิน</HeaderCell>
          <Cell dataKey="receiptNumber" />
        </Column>
        <Column width={160} resizable align="left">
          <HeaderCell>วันเดือนปีของใบเสร็จ</HeaderCell>
          <Cell dataKey="dateReceipt" />
        </Column>
      </Table>

      <Modal
        show={isShowConfirm}
        size="xs"
        onHide={(e) => {
          setIsShowConfirm(false)
        }}
      >
        <Modal.Header>
          <Row style={{ marginLeft: 10, marginBottom: 10 }}>
            <span>ยืนยันการบันทึกรายการที่เลือก</span>
          </Row>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body></Modal.Body>
        <Modal.Footer>
          <Button
            onClick={(e) => {
              setIsShowConfirm(false)
              onSubmit()
            }}
            appearance="primary"
          >
            {/* บันทึก */}
            {formSchema?.buttonTxt?.annualTaxSave}
          </Button>
          <Button
            onClick={(e) => {
              setIsShowConfirm(false)
            }}
            color="blue"
            appearance="primary"
          >
            ยกเลิก
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
